import { clients } from '@/services/client.factory'
import authstore from '@/store/modules/auth';

const places = {
    namespaced: true,
    state: {
        item: null,
        items: [],
        error: null,
        errors: {},
    },
    getters: {
        item: (state) => state.item,
        items: (state) => state.items,
        error: (state) => state.error,
        errors: (state) => state.errors,
    },
    mutations: {
        PLACE_SET_ITEM(state, item) {
            Object.assign(state, { item })
        },
        PLACE_CREATE_ITEM(state, item) {
            state.items.push(item);
        },
        PLACE_UPDATE_ITEM(state, item) {
            Object.assign(state.items[item.editedIndex], item);
            //state.item = Object.assign({}, state.item, item)
        },
        PLACE_SET_ITEMS(state, items) {
            Object.assign(state, { items })
        },
        PLACE_SET_ERROR(state, error) {
            Object.assign(state, { error })
        },
        PLACE_SET_ERRORS(state, errors) {
            Object.assign(state, { errors })
        },
        PLACE_REMOVE_ITEM(state, item) {
            console.log("removeeeee", state.items)
            console.log("itemmmmm", item)
            const index = state.items.findIndex(i => i.id === item.id);
            console.log("indexxx",index)
            state.items.splice(index, 1);
        },
    },
    actions: {
        getItem(context, id) {
        },
        async getItems({ commit }, { page, itemsPerPage, filter }) {
            console.log("get place store filter", filter)
            let body = {
                pageNumber: page,
                pagesize: itemsPerPage,
                searchCriteria: filter,
            }
            console.log("store getitems before")

            await clients.placeServiceClient.searchPlaces(body)
                .then((res) => res.data)
                .then((data) =>
                    commit('PLACE_SET_ITEMS', data)
                )
            console.log("store getitems after")

        },
        
        async create({ commit }, place) {
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            let body = {
                name: place.name,
                cityCode: jwt.city_code,
                countyCode: place.countyCode,
                neighborhoodCode: place.neighborhoodCode,
                categoryId: place.categoryId,
                address: place.address,
                phone: place.phone,
                lat: place.lat,
                lon: place.lon,
            }

            console.log("store addddd before")
            await clients.placeServiceClient.addPlace(body);
            console.log("store addddd after")
            //commit('PLACE_CREATE_ITEM', body);
        },
        async update({ commit }, place) {
            console.log("updateeeeeeeeeee", place)
            let jwt = authstore.getters.jwtDecoded(authstore.state);
            let body = {
                name: place.name,
                cityCode: jwt.city_code,
                countyCode: place.countyCode,
                neighborhoodCode: place.neighborhoodCode,
                categoryId: place.categoryId,
                address: place.address,
                phone: place.phone,
                lat: place.lat,
                lon: place.lon,
                id: place.id
            }
            await clients.placeServiceClient.updatePlace(body);
            //commit('PLACE_UPDATE_ITEM', place);
        },
        async remove({ commit }, place) {
            await clients.placeServiceClient.deletePlace(place.item.id);
            commit('PLACE_REMOVE_ITEM', place.item);

        },

        async uploadPlaceAsset({ commit }, place) {
            console.log("upppppppppload", place.id)
            console.log("upppppppppload", place.file)
            let file = {
                data: place.file,
                fileName: place.file.name
            }
            await clients.placeServiceClient.uploadPlaceAsset(place.id, file);
            //commit('PLACE_UPLOAD_ASSET', place.item);
        },

        async removeAsset({ commit }, place) {
            await clients.placeServiceClient.deletePlaceAsset(place.placeId, place.assetId);
            //commit('ASSET_REMOVE_ITEM', place.placeId);
        },
    }
}

export default places;